export class PaymentModel {
  netTerm: string;
  netTermType: string;
  transactionId: string;
  stripeTransactionId: string;
  approvalRequired: boolean;
  money: number;
}
